/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useTheme } from '../utils/index.js';
export const HeaderBasicButton = React.forwardRef((props, ref) => {
    const { onClick, className, children, style, type = 'button', startIcon, endIcon, as: Element = 'button', styleType, size, ...rest } = props;
    styleType; // To omit and prevent eslint error.
    size; // To omit and prevent eslint error.
    useTheme();
    return (React.createElement(Element, { className: cx('iui-header-breadcrumb-button', className), onClick: onClick, ref: ref, type: type, style: style, ...rest },
        startIcon &&
            React.cloneElement(startIcon, {
                className: startIcon.props.className,
            }),
        children,
        endIcon &&
            React.cloneElement(endIcon, {
                className: endIcon.props.className,
            })));
});
export default HeaderBasicButton;
